import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import {
  getPromptOverviewTabIndex,
  PROMPT_OVERVIEW_TAB_PARAM,
  PromptOverviewTab,
} from "../utils/promptVersionLogsReturnNavigation";

interface UsePromptOverviewTabFromUrlInput {
  onRestoreTabIndex: (tabIndex: number) => void;
}

/** Restores the overview tab from the URL when returning via browser history. */
export const usePromptOverviewTabFromUrl = ({
  onRestoreTabIndex,
}: UsePromptOverviewTabFromUrlInput) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const selectedTab = searchParams.get(PROMPT_OVERVIEW_TAB_PARAM);
    if (selectedTab === PromptOverviewTab.Analytics || selectedTab === PromptOverviewTab.Content) {
      onRestoreTabIndex(getPromptOverviewTabIndex(selectedTab));
    }
  }, [onRestoreTabIndex, searchParams]);
};
